import { loc } from "../i18n/survey";

const shameQuestion = {
  name: 'shame',
  title: loc("quiz.shame.title"),
  type: 'radiogroup',
  description: loc("quiz.shame.description"),
  choices: [
    { value: "Often", text: loc("quiz.shame.choices.often") },
    { value: "Occasionally", text: loc("quiz.shame.choices.occasionally") },
    { value: "Rarely / Never", text: loc("quiz.shame.choices.rarely") },
  ],
  isRequired: true,
};

export {
  shameQuestion,
}